import { isPrivatePath } from './private-path';

export function isClientArea(pathname = window.location.pathname) {
  return isPrivatePath(pathname);
}
